<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Summer Sports Camp</h1>
    <p class="lead mb-0 text-orange-light">Training Champions Every Summer</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <h3 class="fw-bold text-success mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-sun me-2"></i> Summer Sports Camp Gallery
  </h3>

  <div class="row g-3">
    <div class="col-6 col-md-3" *ngFor="let img of campImages">
      <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="Summer Sports Camp" class="img-fluid w-100" style="object-fit: cover; height: 200px;">
      </div>
    </div>
  </div>
</div>
